import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage: React.FC = () => (
  <div style={{
    maxWidth: 720,
    margin: '0 auto',
    padding: '48px 24px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: 'var(--text-primary)',
    lineHeight: 1.7,
  }}>
    <Link to="/login" style={{ color: '#0d9488', textDecoration: 'none', fontSize: 14 }}>
      &larr; Back to login
    </Link>

    <h1 style={{ fontSize: 28, fontWeight: 700, marginTop: 24, marginBottom: 8 }}>
      Privacy &amp; Data
    </h1>
    <p style={{ color: 'var(--text-secondary)', fontSize: 14, marginBottom: 32 }}>
      Last updated: February 2026
    </p>

    <Section title="What data we collect">
      <p>
        When you create an account we store your <strong>name</strong>, <strong>email address</strong>,
        and <strong>organisation</strong>. We also record login timestamps, the pages you visit inside
        the application, and any files or molecules you upload.
      </p>
    </Section>

    <Section title="How we use your data">
      <ul>
        <li>To authenticate you and enforce access controls.</li>
        <li>To provide the chemistry research features you request (search, import, enrichment).</li>
        <li>To generate aggregate usage analytics visible to your organisation's administrator.</li>
        <li>We do <strong>not</strong> sell your data or share it with third parties for marketing.</li>
      </ul>
    </Section>

    <Section title="Where your data is stored">
      <p>
        All data is stored on infrastructure controlled by your organisation. Adroit is a
        self-hosted platform &mdash; your chemical structures, files, and personal information never
        leave your servers unless you explicitly share them.
      </p>
    </Section>

    <Section title="Your rights">
      <ul>
        <li><strong>Data export</strong> &mdash; You can request a full export of your personal data at any time from your account settings.</li>
        <li><strong>Data correction</strong> &mdash; You can update your name and email from your account settings.</li>
        <li><strong>Account deletion</strong> &mdash; You can request permanent deletion of your account. Your data will be anonymised within 30 days.</li>
      </ul>
    </Section>

    <Section title="Cookies &amp; local storage">
      <p>
        We use a single authentication token stored in your browser's local storage. We do not use
        tracking cookies or third-party analytics scripts.
      </p>
    </Section>

    <Section title="Contact">
      <p>
        For privacy-related queries, contact your organisation's administrator or email{' '}
        <strong>privacy@adroitai.ai</strong>.
      </p>
    </Section>
  </div>
);

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section style={{ marginBottom: 28 }}>
    <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8, color: 'var(--text-primary)' }}>{title}</h2>
    <div style={{ fontSize: 15, color: 'var(--text-secondary)' }}>{children}</div>
  </section>
);

export default PrivacyPage;
